import { gsap } from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

export const slideFromLeft = () => {
	const containers = document.querySelectorAll(".cw-slide-left-js");

	containers.forEach((container) => {
		const items = container.querySelectorAll(":scope > *");

		if (!items.length) return;

		gsap.fromTo(
			items,
			{
				opacity: 0,
				x: -80,
				filter: "blur(10px)",
			},
			{
				opacity: 1,
				x: 0,
				filter: "blur(0px)",
				duration: 0.9,
				ease: "power3.out",
				stagger: 0.12,
				scrollTrigger: {
					trigger: container,
					start: "top 80%",
					end: "bottom 20%",
					toggleActions: "play reverse play reverse",
				},
			}
		);
	});
};

export const slideFromRight = () => {
	const containers = document.querySelectorAll(".cw-slide-right-js");

	containers.forEach((container) => {
		const items = container.querySelectorAll(":scope > *");

		if (!items.length) return;

		gsap.fromTo(
			items,
			{
				opacity: 0,
				x: 80,
				filter: "blur(10px)",
			},
			{
				opacity: 1,
				x: 0,
				filter: "blur(0px)",
				duration: 0.9,
				ease: "power3.out",
				stagger: 0.12,
				scrollTrigger: {
					trigger: container,
					start: "top 80%",
					end: "bottom 20%",
					toggleActions: "play reverse play reverse",
				},
			}
		);
	});
};

export const teamMembersPinnedScroll = () => {
	const mm = gsap.matchMedia();

	mm.add("(min-width: 993px)", () => {
		const sections = gsap.utils.toArray(".team-members");
		const animations = [];

		sections.forEach((section) => {
			const wrapper = section.querySelector(
				".team-members__wrapper"
			);

			const photos = section.querySelector(
				".team-members__photos"
			);

			const ceo = section.querySelector(
				".team-members__ceo"
			);

			if (!wrapper || !photos || !ceo) return;

			section.classList.add("team-members--pinned");

			const movingContent = [photos, ceo];

			const getTravelDistance = () => {
				const ceoBottom = ceo.offsetTop + ceo.offsetHeight;
				const viewportHeight = section.clientHeight;
				const bottomSpacing = 280;

				return Math.max(
					0,
					ceoBottom - viewportHeight + bottomSpacing
				);
			};

			const tween = gsap.to(movingContent, {
				y: () => -getTravelDistance(),
				ease: "none",
				overwrite: "auto",

				scrollTrigger: {
					id: "team-members-pinned",
					trigger: section,
					start: "top top",
					end: () => `+=${Math.max(1, getTravelDistance())}`,
					scrub: 1,
					pin: true,
					pinSpacing: true,
					anticipatePin: 1,
					refreshPriority: 10,
					invalidateOnRefresh: true
				}
			});

			animations.push({
				tween,
				movingContent,
				section
			});
		});
		requestAnimationFrame(() => {
			requestAnimationFrame(() => {
				ScrollTrigger.refresh();
			});
		});

		return () => {
			animations.forEach(
				({ tween, movingContent, section }) => {
					tween.scrollTrigger?.kill();
					tween.kill();

					gsap.set(movingContent, {
						clearProps: "transform"
					});

					section.classList.remove(
						"team-members--pinned"
					);
				}
			);
		};
	});
};
